import { useState } from 'react';

import { CalendarDays } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';
import { Calendar } from '@nesso/ui/primitives/calendar';
import { Field, FieldLabel } from '@nesso/ui/primitives/field';
import { Popover, PopoverContent, PopoverTrigger } from '@nesso/ui/primitives/popover';

import type { Payment } from '@/entities/payment';
import { formatNumericShortDate, getStartOfDay } from '@/shared/lib/time-utils';

type Props = {
    value: Date;
    payment: Payment;
    disabled?: boolean;
    onChange: (date: Date) => void;
};

export function RefundPaymentSheetDate({ value, payment, disabled, onChange }: Props) {
    const [open, setOpen] = useState(false);

    return (
        <Field className="w-fit">
            <FieldLabel htmlFor="refund-payment-date">Refund date</FieldLabel>
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button
                        id="refund-payment-date"
                        type="button"
                        variant="outline"
                        disabled={disabled}
                        className="h-auto w-fit justify-start border-input bg-input-background px-4 py-2 text-base font-normal has-[>svg]:px-4"
                    >
                        <CalendarDays />
                        {formatNumericShortDate(value)}
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                        mode="single"
                        required
                        selected={value}
                        defaultMonth={value}
                        disabled={[
                            { before: getStartOfDay(payment.paidAt) },
                            { after: new Date() },
                        ]}
                        onSelect={(date) => {
                            onChange(date);
                            setOpen(false);
                        }}
                    />
                </PopoverContent>
            </Popover>
        </Field>
    );
}
